import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import animated from "animate.css";
import "animate.css";
import vue3videoPlay from "vue3-video-play"; // 引入组件
import "vue3-video-play/dist/style.css"; // 引入css
import "./assets/css/admin-common.css";
import permissionDirective from "./directives/permission";

const app = createApp(App);
app.use(store).use(router).use(vue3videoPlay);
app.directive("permission", permissionDirective);
app.mount("#app");
